const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        sorter: true,
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
    },
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        sorter: true,
        render: defaultRender
    },
    {
        title: 'Approved On',
        dataIndex: 'actionDate',
        sorter: true,
        render: defaultRender
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
        render: defaultRender
    },
    {
        title: 'Action',
        dataIndex: 'action'
    }
];

export default columns;